<main id="main" class="main__offset-header">
  <section class="container">
    <h1>EuroGeographics Privacy Statement</h1>
    <app-privacy-content></app-privacy-content>
  </section>
</main>
<app-footer showBackToTop="true" target="header"></app-footer>
